import type { FaireProductEntity } from "../../entity_types/product";

export const p_sps53hgqsd: FaireProductEntity = {
  token: "p_sps53hgqsd",
  type: "product",
  name: "Puffin Socks - Mate For Life",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/df8a1690300ec82dfab9024460ded5d68c4f67f0a64f0450249245d9a3660f82.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/858fbde7beeea7cfb2f8be9a7ea85ad9d4b96fac00857ee8f1af8694f3636b4c.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
